import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { store } from "../../../store";
import {
  ClearFeatureSetAction,
  DeleteFeatureSetAction,
  GetFeatureSetAction,
  getFeatureSetSelector,
  getFeatureSetsSelector,
  SetFeatureSetAction,
  UpdateFeatureSetAction,
} from "../../../store/reducers/offeringsReducer";
import { useNavigate, useParams } from "react-router-dom";
import { DetailPageHeader } from "../../../ui-components/pageLayout/DetailPageHeader";
import styled from "styled-components";
import FeatureSetBasicInformationAccordion from "./accordions/FeatureSetBasicInformationAccordion";
import FeatureSetMediaCollectionsAccordion from "./accordions/FeatureSetMediaCollectionsAccordion";
import FeatureSetProductAccordion from "./accordions/FeatureSetProductAccordion";
import { IFeatureSet } from "@nendaTypes/NendaTypes";
import { FeatureSet } from "@client/models/Offerings/featureSet";
import { fromJson } from "@client/models/modelHelpers";

export const CustomModalWrapper = styled.div`
  .modal-content {
    width: 900px;
  }
`;

export const ModalField = styled.div`
  margin-bottom: 5px;
  .first-label {
    margin-right: 15px;
  }
  .checkbox-label {
    margin-left: 20px;
  }

  input {
    margin-left: 5px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: right;
`;

const UpdateFeatureSetSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required*"),
});

export const FeatureSetDetails: React.FC = () => {
  const featureSets = useSelector(getFeatureSetsSelector);
  const featureSet = useSelector(getFeatureSetSelector);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const history = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (!featureSet && !isDeleting) {
      const foundFeatureSet = featureSets?.find(
        (featureSet) => featureSet._id == params.id
      );
      foundFeatureSet
        ? store.dispatch(SetFeatureSetAction(foundFeatureSet))
        : store.dispatch(GetFeatureSetAction(params.id || ""));
    } else if (!featureSet && isDeleting) {
      redirect();
    }
  }, [featureSets, featureSet]);

  useEffect(() => {
    return () => {
      store.dispatch(ClearFeatureSetAction());
    };
  }, []);

  const submitUpdateFeatureSet = (values: IFeatureSet) => {
    store.dispatch(UpdateFeatureSetAction(values));
  };

  const submitDeleteFeatureSet = () => {
    setIsDeleting(true);
    store.dispatch(DeleteFeatureSetAction(params.id || ""));
  };

  const redirect = () => {
    history("/admin/offerings/feature-sets/");
  };

  return (
    <>
      {featureSet && (
        <>
          <Formik
            initialValues={featureSet}
            validationSchema={UpdateFeatureSetSchema}
            onSubmit={(values: IFeatureSet) => {
              submitUpdateFeatureSet(values);
            }}
          >
            {({ handleSubmit }) => (
              <Form>
                <DetailPageHeader
                  title="Feature Set Metadata"
                  entity={fromJson(FeatureSet, featureSet)}
                  onDelete={submitDeleteFeatureSet}
                  onBack={redirect}
                />
                <FeatureSetBasicInformationAccordion />
                <FeatureSetMediaCollectionsAccordion />
                <FeatureSetProductAccordion />
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};
